import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { colors } from "../../utils/styles";

export default function StepIndicator({ steps, currentStep }) {
  const isCompact = useMediaQuery("(max-width: 670px)");
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 0, marginBottom: 16 }}>
      {steps.map((s, i) => (
        <div
          key={i}
          style={{ display: "flex", alignItems: "center", flex: i < steps.length - 1 ? 1 : "none" }}
        >
          <div
            style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
            onClick={s.onClick}
          >
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: i <= currentStep ? colors.navy : colors.sectionBg,
                color: i <= currentStep ? colors.white : colors.textMuted,
                fontSize: 14,
                fontWeight: 700,
                border: i === currentStep ? `2px solid ${colors.gold}` : "2px solid transparent",
                transition: "all 0.2s",
                flexShrink: 0
              }}
            >
              {i + 1}
            </div>
            {!isCompact && (
              <span
                style={{
                  fontSize: 12,
                  fontWeight: i === currentStep ? 700 : 500,
                  color: i <= currentStep ? colors.navy : colors.textMuted,
                  lineHeight: 1.3,
                  maxHeight: "2.6em",
                  overflow: "hidden",
                  wordBreak: "keep-all"
                }}
              >
                {s.label}
              </span>
            )}
          </div>
          {i < steps.length - 1 && (
            <div
              style={{
                flex: 1,
                height: 2,
                background: i < currentStep ? colors.gold : colors.borderLight,
                margin: isCompact ? "0 8px" : "0 12px",
                minWidth: isCompact ? 12 : 20
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
}
